import { render, staticRenderFns } from "./SysRoleMan.vue?vue&type=template&id=dee6ddd6&scoped=true"
import script from "./SysRoleMan.vue?vue&type=script&lang=js"
export * from "./SysRoleMan.vue?vue&type=script&lang=js"
import style0 from "./SysRoleMan.vue?vue&type=style&index=0&id=dee6ddd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee6ddd6",
  null
  
)

export default component.exports